// eslint-disable-next-line import/export
import * as loaders from "@lts/loaders/legacy/legacy-glTF1FileLoader";
export { loaders };
export default loaders;
